import React from 'react'
import injectSheet from 'react-jss'
import styles from './pagination.styles'
import ArrowLeft from 'react-icons/lib/fa/angle-left'
import ArrowRight from 'react-icons/lib/fa/angle-right'
import Button from 'pobble-components/dist/button'

const Pagination = ({ classes, total, current, onNext, onPrev }) => {
  return (
    <div className={classes.container}>
      <Button simple action={onPrev}>
        <ArrowLeft />
      </Button>
      <span className={classes.hiddenMobile}>Page&nbsp;</span>
      {current + 1} of {total}
      <Button simple action={onNext}>
        <ArrowRight />
      </Button>
    </div>
  )
}

export default injectSheet(styles)(Pagination)
